import "./Page.styl";

import React from "react";

import Helmet from "react-helmet";
import { connect } from "react-redux";
import { Link } from "react-router";
import Match from "../components/Match";

import { Container, Row, Col } from "reactstrap";

import Header from "../components/Header/Header";
import Footer from "../components/Footer/Footer";

class Page extends React.Component {
  constructor() {
    super();
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  redirect(to) {
    const { router } = this.context;
    // so that folks can unit test w/o hassle
    if (router) router.transitionTo(to);
  }

  render() {
    const { googleMapsApiKey, pathname } = this.props;

    const seoTitle = "Polityka prywatności";
    const seoDescription = "";

    return (
      <div className="legal-page">
        <Helmet
          title={seoTitle}
          description={seoDescription}
          meta={[
            { name: "description", content: seoDescription },
            { property: "og:type", content: "website" },
            { property: "og:title", content: seoTitle },
            { property: "og:description", content: seoDescription },
            {
              property: "og:image",
              content: "https://opiekujsie.pl/static/home-background.jpg"
            }
          ]}
        />
        <Header />

        <div className="hero-section">
          <div className="width-wrapper">
            <div className="title-large">Polityka prywatności</div>
          </div>
        </div>

        <div className="legal-section">
          <div className="width-wrapper">
            <Row className="flex-items-xs-center">
              <Col xs="12">
                <div className="title">Postanowienia ogólne</div>
                <div className="content">
                  1. Operatorem serwisu opiekujsie.pl jest PQ studio Sp. z o.o.
                  NIP: 5993201337 ul. Żwirowa 54 66-400 Gorzów Wielkopolski
                </div>
                <div className="content">
                  2. Serwis realizuje funkcje pozyskiwania informacji o
                  użytkownikach i ich zachowaniu w następujący sposób:
                </div>
                <div className="content right">
                  a. Poprzez dobrowolnie wprowadzone w formularzach informacje.
                </div>
                <div className="content right">
                  b. Poprzez zapisywanie w urządzeniach końcowych pliki cookie
                  (tzw. "ciasteczka").
                </div>
                <div className="content right">
                  c. Poprzez zapisywanie w urządzeniach końcowych local storage.
                </div>
                <div className="content">
                  3. Oferta oraz podane ceny mają jedynie charakter informacyjny
                  i nie stanowią oferty handlowej w rozumieniu Art. 66 par.1
                  Kodeksu Cywilnego. PQ studio interaktywne zastrzega sobie
                  prawo do zmiany cen oraz opisywanych na niniejszej stronie
                  usług. Podane ceny są cenami netto (bez uwzględnienia podatku
                  VAT).
                </div>

                <div className="title">Polityka Cookies</div>
                <div className="content">
                  1. Serwis korzysta z plików cookies.
                </div>
                <div className="content">
                  2. Pliki cookies (tzw. „ciasteczka”) stanowią dane
                  informatyczne, w szczególności pliki tekstowe, które
                  przechowywane są w urządzeniu końcowym Użytkownika Serwisu i
                  przeznaczone są do korzystania ze stron internetowych Serwisu.
                  Cookies zazwyczaj zawierają nazwę strony internetowej, z
                  której pochodzą, czas przechowywania ich na urządzeniu
                  końcowym oraz unikalny numer.
                </div>
                <div className="content">
                  3. Podmiotem zamieszczającym na urządzeniu końcowym
                  Użytkownika Serwisu pliki cookies oraz uzyskującym do nich
                  dostęp jest operator Serwisu.
                </div>
                <div className="content">
                  4. Pliki cookies wykorzystywane są w następujących celach:
                </div>
                <div className="content right">
                  a. tworzenia statystyk, które pomagają zrozumieć, w jaki
                  sposób Użytkownicy Serwisu korzystają ze stron internetowych,
                  co umożliwia ulepszanie ich struktury i zawartości;
                </div>
                <div className="content right">
                  b. utrzymanie sesji Użytkownika Serwisu (po zalogowaniu),
                  dzięki której Użytkownik nie musi na każdej podstronie Serwisu
                  ponownie wpisywać loginu i hasła;
                </div>
                <div className="content right">
                  c. określania profilu użytkownika w celu wyświetlania mu
                  dopasowanych materiałów w sieciach reklamowych, w
                  szczególności sieci Google.
                </div>
                <div className="content">
                  5. W ramach Serwisu stosowane są dwa zasadnicze rodzaje plików
                  cookies: „sesyjne” (session cookies) oraz „stałe” (persistent
                  cookies). Cookies „sesyjne” są plikami tymczasowymi, które
                  przechowywane są w urządzeniu końcowym Użytkownika do czasu
                  wylogowania, opuszczenia strony internetowej lub wyłączenia
                  oprogramowania (przeglądarki internetowej). „Stałe” pliki
                  cookies przechowywane są w urządzeniu końcowym Użytkownika
                  przez czas określony w parametrach plików cookies lub do czasu
                  ich usunięcia przez Użytkownika.
                </div>
                <div className="content">
                  6. Oprogramowanie do przeglądania stron internetowych
                  (przeglądarka internetowa) zazwyczaj domyślnie dopuszcza
                  przechowywanie plików cookies w urządzeniu końcowym
                  Użytkownika. Użytkownicy Serwisu mogą dokonać zmiany ustawień
                  w tym zakresie. Przeglądarka internetowa umożliwia usunięcie
                  plików cookies. Możliwe jest także automatyczne blokowanie
                  plików cookies Szczegółowe informacje na ten temat zawiera
                  pomoc lub dokumentacja przeglądarki internetowej.
                </div>
                <div className="content">
                  7. Ograniczenia stosowania plików cookies mogą wpłynąć na
                  niektóre funkcjonalności dostępne na stronach internetowych
                  Serwisu.
                </div>
                <div className="content">
                  8. Pliki cookies zamieszczane w urządzeniu końcowym
                  Użytkownika Serwisu i wykorzystywane mogą być również przez
                  współpracujących z operatorem Serwisu reklamodawców oraz
                  partnerów.
                </div>
                <div className="content">
                  9. Zalecamy przeczytanie polityki ochrony prywatności tych
                  firm, aby poznać zasady korzystania z plików cookie
                  wykorzystywane w statystykach: Polityka ochrony prywatności
                  Google Analytics
                </div>
                <div className="content">
                  10. Pliki cookie mogą być wykorzystane przez sieci reklamowe,
                  w szczególności sieć Google, do wyświetlenia reklam
                  dopasowanych do sposobu, w jaki użytkownik korzysta z Serwisu.
                  W tym celu mogą zachować informację o ścieżce nawigacji
                  użytkownika lub czasie pozostawania na danej stronie.
                </div>
                <div className="content">
                  11. W zakresie informacji o preferencjach użytkownika
                  gromadzonych przez sieć reklamową Google użytkownik może
                  przeglądać i edytować informacje wynikające z plików cookies
                  przy pomocy narzędzia: https://www.google.com/ads/preferences/
                </div>

                <div className="title">Informacje w formularzach</div>
                <div className="content">
                  1. Serwis zbiera informacje podane dobrowolnie przez
                  użytkownika
                </div>
                <div className="content">
                  2. Serwis może zapisać ponadto informacje o parametrach
                  połączenia (oznaczenie czasu, adres IP)
                </div>
                <div className="content">
                  3. Dane w formularzu nie są udostępniane podmiotom trzecim
                  inaczej, niż za zgodą użytkownika.
                </div>
                <div className="content">
                  4. Dane podane w formularzu mogą stanowić zbiór potencjalnych
                  klientów, zarejestrowany przez Operatora Serwisu w rejestrze
                  prowadzonym przez Generalnego Inspektora Ochrony Danych
                  Osobowych.
                </div>
                <div className="content">
                  5. Dane podane w formularzu są przetwarzane w celu wynikającym
                  z funkcji konkretnego formularza, np w celu dokonania procesu
                  obsługi zgłoszenia serwisowego lub kontaktu handlowego.
                </div>
              </Col>
            </Row>
          </div>
        </div>

        <Footer />
      </div>
    );
  }
}

Page.contextTypes = {
  router: React.PropTypes.object.isRequired
};

export default connect(
  state => ({
    googleMapsApiKey: state.config.googleMapsApiKey
  }),
  {}
)(Page);



/** WEBPACK FOOTER **
 ** ./src/browser/legal/Page.js
 **/